import { useFhirStore } from '@/stores/fhirStore';
import { useGeneralStore } from '@/stores/generalStore';
import fhirDao from '@/helperScripts/fhirHelpers/dao/fhirDao';
import icdProcessor from '@/helperScripts/icdCodes/icdProcessor';

//Methods for setting important Fhir resources

const setGermanDistrictsCs = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchCodeSystemByUrl(
    fhirStore.urls.germanDistrictsCsUrl,
    false
  );

  fhirStore.codeSystems.germanDistrictsCs =
    response.data.entry[0].resource.concept;
};

const setCtStatusCodeSystem = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchCodeSystemByUrl(
    // Url encoding necessary as url contains '#'
    encodeURIComponent(fhirStore.urls.ctStatusCodeSystemUrl),
    false
  );

  fhirStore.codeSystems.ctStatusCodeSystem =
    response.data.entry[0].resource.concept;
};

const setConditionValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchValueSetByUrl(
    fhirStore.urls.conditionVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.conditionValueSet =
      response.data.entry[0].resource.compose.include[0].concept;

    //Create copy of original icd ValueSet where each entry has additional info about the specific and general icd category, extracted from the display value. Assumes the display values have the structure '<general category>|<specific diagnosis>'
    fhirStore.valueSets.conditionValueSetWithSpecificAndGeneralInfoSeparated =
      icdProcessor.getConditionValueSetWithSeparatedGeneralAndSpecificInfo(
        fhirStore.valueSets.conditionValueSet
      );
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setRegionValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.regionVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.regionValueSet = response.data.expansion.contains;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setEntityValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.entityVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.entityValueSet = response.data.expansion.contains;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setHighMediumLowValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchValueSetByUrl(
    fhirStore.urls.hmlVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.hmlValueSet =
      response.data.entry[0].resource.compose.include[0].concept;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setTreatmentLineValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchValueSetByUrl(
    fhirStore.urls.treatmentLineVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.treatmentLineValueSet =
      response.data.entry[0].resource.compose.include[0].concept;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setSubtypeValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchValueSetByUrl(
    fhirStore.urls.subtypeVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.subtypeValueSet =
      response.data.entry[0].resource.compose.include[0].concept;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setCityValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.cityVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.cityValueSet = response.data.expansion.contains;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setSubstancesValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.substancesVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.substancesValueSet = response.data.expansion.contains;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setUiccValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.uiccVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.uiccValueSet = response.data.expansion.contains;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setBiomarkerValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchValueSetByUrl(
    fhirStore.urls.biomarkerVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.biomarkerValueSet =
      response.data.entry[0].resource.compose.include[0].concept;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setHgncValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.hgncVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.hgncValueSet = response.data.expansion.contains;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setIdentifierValueSet = async () => {
  const response = await fhirDao.searchAndExpandValueSetByUrl(
    useFhirStore().urls.identifierVsUrl,
    false
  );

  if (response.status == 200) {
    useFhirStore().valueSets.identifierValueSet =
      response.data.expansion.contains;
    // Initialize available identifier systems for selection in TrialDetails
    useGeneralStore().unusedIdentifierSystems = Array.from(
      useFhirStore().valueSets.identifierValueSet
    );
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setContactOriginValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.contactOriginVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.contactOriginValueSet =
      response.data.expansion.contains;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setFacilityStatusValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.catFacilityStatusVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.facilityStatusValueSet =
      response.data.expansion.contains;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setValidStatusValues = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.fhirStatusVsUrl,
    false
  );

  if (response.status == '200') {
    fhirStore.validFhirStatusValues = response.data.expansion.contains;
  } else {
    alert(this.$t('error.errorDuringRequest'));
    console.log('Fehler');
  }
};

const setCtCoreStatusValueSet = async () => {
  let fhirStore = useFhirStore();

  const response = await fhirDao.searchAndExpandValueSetByUrl(
    fhirStore.urls.ctCoreStatusVsUrl,
    false
  );

  if (response.status == 200) {
    fhirStore.valueSets.ctCoreStatusValueSet = response.data.expansion.contains;
  } else {
    console.log('Fehler bei ValueSet-Abfrage');
  }
};

const setCtConceptMap = async () => {
  let fhirStore = useFhirStore();

  //Gets available Status values (code and display) from the Server (source: ConceptMap.)
  let vals = [];
  const response = await fhirDao.searchConceptMapByUrl(
    fhirStore.urls.statusConceptMapUrl,
    false
  );

  if (response.status == '200') {
    vals = response.data.entry[0].resource.group[0].element;
    fhirStore.ctConceptMap = vals;
  } else {
    alert(this.$t('error.errorDuringRequest'));
    console.log('Fehler bei Abfrage der Status-ConceptMap');
  }
  fhirStore.ctStatusValues.length = 0;
  vals.forEach((v) => {
    let tempObj = { code: '', display: '' }; //Will hold code and display values
    tempObj.code = v.target[0].code;
    tempObj.display = v.target[0].display;
    fhirStore.ctStatusValues.push(tempObj);
  });
};

/**
 * Initializes all the big neccessary Fhir resources in the corresponding store.
 */
const initFhirResourcesInStore = async () => {
  const fhirStore = useFhirStore();

  try {
    await Promise.all([
      setCtConceptMap(),
      setValidStatusValues(),
      setSubstancesValueSet(),
      setUiccValueSet(),
      setHgncValueSet(),
      setBiomarkerValueSet(),
      setConditionValueSet(),
      setSubtypeValueSet(),
      setCityValueSet(),
      setTreatmentLineValueSet(),
      setHighMediumLowValueSet(),
      setCtStatusCodeSystem(),
      setGermanDistrictsCs(),
      setEntityValueSet(),
      setRegionValueSet(),
      setIdentifierValueSet(),
      setContactOriginValueSet(),
      setFacilityStatusValueSet(),
      setCtCoreStatusValueSet(),
    ]);

    fhirStore.resourceInitializationSuccessful = true;

    console.log('Successfully initialized fhir resources');
  } catch (error) {
    fhirStore.resourceInitializationSuccessful = false;
    console.log({
      error,
      msg: 'Failed to completely initialize fhir resources.',
    });
  }
  //Mark initialization process as done
  fhirStore.resourceInitializaitionDone = true;
};

export default {
  setCtConceptMap,
  setValidStatusValues,
  setSubstancesValueSet,
  setUiccValueSet,
  setHgncValueSet,
  setBiomarkerValueSet,
  setConditionValueSet,
  setSubtypeValueSet,
  setCityValueSet,
  setTreatmentLineValueSet,
  setHighMediumLowValueSet,
  setCtStatusCodeSystem,
  setGermanDistrictsCs,
  setEntityValueSet,
  setRegionValueSet,
  setIdentifierValueSet,
  setContactOriginValueSet,
  initFhirResourcesInStore,
  setFacilityStatusValueSet,
  setCtCoreStatusValueSet,
};
